export const sort = [
  { label: "Id", name: "id", style: { width: 200 } },
  { label: "Nazwa", name: "name" },
  {
    label: "Allegro - nazwa prod.",
    name: "allegro_responsible_producer_name",
  },
  {
    label: "Erli - nazwa prod.",
    name: "erli_responsible_producer_name",
  },
  {
    label: "Amazon - GPRS man. email",
    name: "amazon_gpsr_manufacturer_email",
  },
  { label: "Marki", name: "brands" },
];

export const filters = [
  {
    type: "input",
    name: "name",
    sort_id: "name",
    search_type: "matches",
  },
    {
    type: "input",
    name: "allegro_responsible_producer_name",
    sort_id: "allegro_responsible_producer_name",
    search_type: "matches",
  },
    {
    type: "input",
    name: "erli_responsible_producer_name",
    sort_id: "erli_responsible_producer_name",
    search_type: "matches",
  },
    {
    type: "input",
    name: "amazon_gpsr_manufacturer_email",
    sort_id: "amazon_gpsr_manufacturer_email",
    search_type: "matches",
  },
];
